import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@mui/material';

import type { MiddlewhereFilter } from 'app/main/components/filter/FilterItemManager';
import { ModuleSearchField, ResponsiveDialog, useSettings, useUserData, Utils } from 'app/main/components';

interface DemsRecipientsAddSingleDialogProps {
	openDialog: boolean;
	switchOpenDialog: VoidFunction;
	demsUid: string;
	table: string;
	defaultFilters: MiddlewhereFilter[];
	updateRefresh: VoidFunction;
}

export default function DemsRecipientsAddSingleDialog(props: DemsRecipientsAddSingleDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings(props.table);
	const userData = useUserData();

	const [uid, setUid] = React.useState<string | null>(null);

	const addRecipient = () => {
		Utils.executeStored({
			action: 'st_dems_recipients_add_multiple',
			dispatch,
			data: {
				derc_dems_uid: props.demsUid,
				derc_user_created_uid: userData.user_uid,
				filters: [
					...props.defaultFilters,
					{ filt_field: `${settings.modu_short}_uid`, filt_clause: 'equals', filt_value: uid }
				]
			},
			successHandler: () => {
				setUid(null);
				dispatch(Utils.alertSuccessMsg(t));
				props.switchOpenDialog();
				props.updateRefresh();
			}
		});
	};

	return (
		<ResponsiveDialog
			open={props.openDialog}
			onClose={props.switchOpenDialog}
			maxWidth="xs"
			title={t('DEMS_SECTION_ADD_TITLE')}
			content={
				<ModuleSearchField
					name={`${settings.modu_short}_uid`}
					label={t(`MODULE_${settings.modu_title}_NAME_SINGULAR`)}
					module={settings.modu_title}
					uid={uid}
					filters={props.defaultFilters}
					isEdit
					sendChange={(_name, newValue) => setUid(newValue)}
				/>
			}
			actions={
				<>
					<Button onClick={props.switchOpenDialog}>{t('DIALOG_ACTION_BACK')}</Button>
					<Button disabled={!uid} onClick={addRecipient}>
						{t('DIALOG_ACTION_ADD')}
					</Button>
				</>
			}
		/>
	);
}
